var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserApi } from './apis/user-api.interface';
import { API_VIEW_TYPE_TRANSLATE_MAP, VIEW_TYPE_ORDER } from '../constants';
import _ from 'lodash';
let UserRepositoryImpl = class UserRepositoryImpl {
    constructor(_userApi) {
        this._userApi = _userApi;
    }
    getUserInitData() {
        return this._userApi.getUserInitApi().then((data) => {
            const product_list = _.get(data, 'user_info.product_list', []);
            let go_to_where = _.get(data, 'user_setting.go_to_where');
            if (!_.includes(product_list, go_to_where)) {
                if (product_list.length === 1) {
                    go_to_where = product_list[0];
                }
                else if (!product_list.length) {
                    go_to_where = 'pro';
                }
                else {
                    go_to_where = '';
                }
                data.user_setting.go_to_where = go_to_where;
            }
            return {
                user_info: {
                    ...data.user_info,
                    view_type_list: this._transformViewType(data.user_info.view_type_list),
                },
                user_capacity: data.user_capacity,
                user_permission: data.user_permission,
                user_setting: data.user_setting,
            };
        });
    }
    async getUserDataCount() {
        const data = await this._userApi.getUserDataCountApi();
        return {
            total_company_data_count: data.total_company_data_count,
            total_personal_data_count: data.total_person_data_count,
        };
    }
    _transformViewType(viewTypes) {
        const transformedViewTypes = _.map(viewTypes, (viewType) => {
            return API_VIEW_TYPE_TRANSLATE_MAP[viewType];
        });
        return _.sortBy(transformedViewTypes, (viewType) => {
            return _.indexOf(VIEW_TYPE_ORDER, viewType);
        });
    }
};
UserRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(UserApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserApi !== "undefined" && UserApi) === "function" ? _a : Object])
], UserRepositoryImpl);
export { UserRepositoryImpl };
